export default {
  state: {
    routeTrack: null,
  },
  mutations: {
    SET_ROUTE_TRACK(state, routeTrack) {
      state.routeTrack = routeTrack;
    },
  },
};
